export default {
  props: {
    quality_attributes: { required: true },
    quality_samplings: { required: true },
    quality_inspect: { required: true },
    quality_group: { required: true },
    quality_template: { required: true },
  },
  computed: {
    group_ranges: function () {
      return this.quality_group?.quality_group_ranges ?? [];
    },
    attribute_ranges: function () {
      return this.quality_group?.quality_attributes.map(attr => attr.quality_attribute_ranges).flat()
    },
    samplings: function () {
      return this.inspect?.quality_samplings ?? [];
    },
    show_group_stats: function () {
      return this.quality_template
                 .quality_template_groups
                 .find(tg => tg.quality_group_id == this.quality_group.id)
                 ?.show_stats
    },
    show_total: function () {
      if (!this.quality_attributes) return false;

      return this.quality_attributes
                 ?.map(attr => attr.show_total)
                 ?.includes(true);
    }
  },
  methods: {
    getSamplingDetail: function (quality_sampling, quality_attribute) {
      if (Object.keys(quality_sampling).length === 0) return;

      return this.getSamplingGroup(quality_sampling)
        ?.quality_sampling_details?.find(
          (sampling_detail) =>
            sampling_detail.quality_attribute_id === quality_attribute.id
        );
    },
    getAttrValue: function (eq_sampling, eq_attribute_id) {
      if (Object.keys(eq_sampling).length === 0) return;

      return this.getSamplingDetail(eq_sampling, { id: eq_attribute_id })?.value;
    },
    getGeneral: function (inspect, attr) {
      return inspect.quality_generals?.find(
        (quality_general) =>
          quality_general.quality_attribute_id === attr.id
      );
    },
    getGeneralRange: function (attr, quality_attribute_range) {
      return (this.getGeneral(this.quality_inspect, attr)?.quality_general_ranges ?? [])
                 .find(general => general.quality_attribute_range_id == quality_attribute_range.id)
    },
    getGeneralRangeTotal: function (attr, quality_attribute_range) {
      return this.getGeneralRange(attr, quality_attribute_range)?.total
    },
    getGroupRangeValue: function (sampling, range) {
      return this.getSamplingGroup(sampling)
        ?.quality_sampling_group_ranges?.find(
          (r) => r.quality_group_range_id == range.id
        )?.value;
    },
    getSamplingGroup: function (quality_sampling) {
      return quality_sampling.quality_sampling_groups?.find(
        (sampling_group) =>
          sampling_group.quality_group_id ==
          this.quality_group.id
      );
    },
    getSamplingGroupAvg: function (quality_sampling) {
      return this.getSamplingGroup(quality_sampling)?.average;
    },
    getSamplingGroupMinValue: function (quality_sampling) {
      return this.getSamplingGroup(quality_sampling)?.min_value;
    },
    getSamplingGroupMaxValue: function (quality_sampling) {
      return this.getSamplingGroup(quality_sampling)?.max_value;
    },
    showTotalAttribute: function (quality_attribute) {
      return Boolean(quality_attribute.show_total);
    },
    showStatsAttribute: function (quality_attribute) {
      return Boolean(quality_attribute.show_stats);
    }
  },
};